<!-- 
Dialog for testing error handling.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>
          Test error handling
        </v-toolbar-title>
        <v-spacer/>
        <our-user-guide-button topic="administration-exception-logs" section="diagnostic-tools-error-handling"/>
      </v-toolbar>
      <our-busy-indicator :show="processing"/>
      <v-card-text>
        <p>
          Tells our backend to throw an unhandled exception. 
          If our error handling is functioning correctly 
          the red snackbar will pop up and the logged exception will appear in the exception logs.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat @click="hide">Close</v-btn>
        <v-btn :disabled="processing" flat color="primary" @click="test">
          Test error handling
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { GLOBAL_ERROR_HIDE } from "@/store/system/mutation-types";
import * as action from "@/store/exception-logs/action-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    processing() {
      return this.$store.state.exceptionLogs.throw.processing;
    }
  },
  methods: {
    hide() {
      this.$store.commit(GLOBAL_ERROR_HIDE);
      this.$emit("update:show", false);
    },
    async test() {
      await this.$store.dispatch(action.THROW_EXCEPTION);
      this.$store.dispatch(action.LIST);
    }
  }
};
</script>
